import React, { useContext } from "react";

import { StateContext } from "../../StateContext";
import { VenueContext } from "../../VenueContext";
import Content from "../Content";
import EventSummary from "../EventSummary";
import FramedTitle from "../FramedTitle";
import Tile from "../Tile";

import * as styles from "./styles.module.scss";

export const WhatsOn = () => {
  const venue = useContext(VenueContext);
  const state = useContext(StateContext);
  const past = state.events.past.filter(
    (event) => event.venues.indexOf(venue) > -1,
  );
  const upcoming = state.events.upcoming.filter(
    (event) => event.venues.indexOf(venue) > -1,
  );

  return (
    <>
      <Content>
        <FramedTitle text="What’s on" />
        <div className={styles.eventsContainer}>
          {upcoming.map((event) => (
            <EventSummary key={event.slug} {...event} />
          ))}
        </div>
        {past.length > 0 && (
          <>
            <Tile text="Past events" />
            <div className={styles.eventsContainer}>
              {past.map((event) => (
                <EventSummary key={event.slug} {...event} past />
              ))}
            </div>
          </>
        )}
      </Content>
    </>
  );
};

export default WhatsOn;
